import React from "react";
import "../Css/BlogCard.css";
import { Divider } from "antd";
import moment from "moment";

const BlogCard = ({ value }) => {
  const extractFirstTwoParagraphs = (html) => {
    const div = document.createElement("div");
    div.innerHTML = html;

    const paragraphs = div.querySelectorAll("p"); // Select all <p> tags
    const firstTwoParagraphs = Array.from(paragraphs).slice(0, 1); // Get the first two <p>

    // Create a new div and append the first two paragraphs
    const newDiv = document.createElement("div");
    firstTwoParagraphs.forEach((p) => newDiv.appendChild(p));

    return newDiv.innerHTML; // Return the HTML string with the first two <p> tags
  };

  return (
    <>
      <div className="blogCard-main-div">
        <div className="blogCard-img-div">
          {/* <img className='blogCard-img' src='https://bluenile-blog.r2net.com/wp-content/uploads/2023Q4_ENGT_S01_TBT_503570Y%E2%80%8B_604770y14%E2%80%8B_504211W14%E2%80%8B_603130w14%E2%80%8B_504480W14_504370Y14%E2%80%8B_504440W14_Hero_V2_1440x900.jpg' /> */}
          <img
            src={value.image || `/blog-image/${value.slug}.webp`}
            className="blogCard-img"
            alt="Exibition card"
            onError={(e) => {
              e.target.onerror = null; // Prevents infinite loop in case the demo image also fails
              e.target.src = "https://images.unsplash.com/photo-1601121141461-9d6647bca1ed?q=80&w=1000&auto=format&fit=crop"; // Provide the path to your demo image
            }}
          />
        </div>
        <div>
          <div className="blogCard-text-equal-padding">
            <span className="fw-bold">
              {" "}
              {moment(value.created_at).format("MMMM DD, YYYY")}
            </span>
            <h5 className="pt-3">{value.title}</h5>
            <div
              dangerouslySetInnerHTML={{
                __html: extractFirstTwoParagraphs(value.description),
              }}
            />
            {/* <p dangerouslySetInnerHTML={{ __html: description }} /> */}
            {/* {description} */}
            {/* </p> */}
          </div>
          <Divider />
          <div className="blogCard-text-equal-padding blogCard-text-date">
            {/* <span>
                            Lorem ipsum
                        </span> */}
            {/* <span> •</span> */}

            <span>
              {/* {moment(exibitionDate).format('YYYY-MM-DD')} */}
              <strong className="blogCard-read-more-btn"> READ MORE</strong>
              {/* June 24, 2024 */}
            </span>
          </div>
        </div>
      </div>
    </>
  );
};

export default BlogCard;
